
import React, {useState} from 'react';
import {
    AppBar, createTheme,
    Divider,
    IconButton,
    Menu,
    MenuItem,
    Paper, TableCell,
    TableRow,
    TextField,
    ThemeProvider,
    Toolbar
} from "@mui/material";

import "./Dashboard.css";

import MUIDataTable from "mui-datatables";
import {DASHBOARD_COLUMNS} from "../config/ColumnInfo";
import ExpenseModal from "../modals/ExpenseModal";
import InfoModal from "../modals/SetupModal";

import SettingsIcon from '@mui/icons-material/Settings';
import {getDateOfMonthMap} from "../helper/DateHelper";
import {FULLPAYLOAD} from "../mock/MockData";
import {asyncFetchExpenseAccounts, asyncFetchExpenseManifest, asyncRequestEbidtaPayload} from "../net/QBOCalls";
import ProgressModal from "../modals/ProgressModal";

// images
import IMAGE_RANCHO from "../images/rancho.png";
import IMAGE_TELLTAIL from "../images/telltail.png";
import IMAGE_MOONLIGHT from "../images/moonlight.png";

export default function Dashboard2(props) {

    // THIS IS DEBUG
    // const [payload, setPayload] = useState(props.payload ? props.payload : FULLPAYLOAD);

    const STATE_DEBUG = -1;
    const STATE_LOAD_EXPENSES = 0;
    const STATE_LOAD_MANIFEST = 1;
    const STATE_LOAD_PAYLOAD = 2;
    const STATE_LOADED = 3;
    const STATE_WAITING = 98;
    const STATE_FIRST_TIME_SETUP = 99;

    const defaultPayloadState = {
        state: STATE_LOAD_EXPENSES,
        data: null,
        manifest: null
    };

    const defaultFilter = "TOTAL";

    const [filter, setFilter] = useState(defaultFilter);
    const [currentYear, setCurrentYear] = useState(new Date().getFullYear());
    const [payload, setPayload] = useState(defaultPayloadState);
    const [anchorEl, setAnchorEl] = React.useState(null);
    const [expenseModalOpen, setExpenseModalOpen] = useState(null);

    const filterOptions = createFilterOptions();
    const years = calculateYears();

    const defaultElevation = 10;

    const buildStyle = (idx) => {
        switch (idx) {
            case 1:
                return {backgroundColor: "#d9ead3"}
            case 2:
            case 3:
                return {backgroundColor: "#cfe2f3"}
            case 4:
            case 5:
                return {backgroundColor: "#f4cccc"}
            default:
                return {backgroundColor: "#fce5cd"}
        }
    }

    console.log(payload);

    const cellRenderer = (obj, idx) => {

        return <TableRow key={"row_" + idx}>
            {obj.map((cell, idx) => {
                let c = cell;
                if (idx === 0) {
                    c = new String(c).toUpperCase();
                }

                return <TableCell key={"cell_" + idx} style={buildStyle(idx)}>{c}</TableCell>
            })}
        </TableRow>
    }

    const options = {
        rowsPerPage: 15,
        selectableRows: "none",
        print: false,
        customRowRender: cellRenderer
    };

    const theme = createTheme({

        palette: {
            primary: {
                main: "#0000b7"
            },
        },
        components: {
            MuiTableCell: {
                styleOverrides: {
                    root: {
                        textAlign: "center",
                    }
                },
            },
            MUIDataTableSelectCell: {
                styleOverrides: {
                    headerCell: {
                        backgroundColor: 'blue',
                    },
                },
            },
            MuiTableFooter: {
                styleOverrides: {
                    root: {
                        '& .MuiToolbar-root': {
                            backgroundColor: 'white',
                        },
                    },
                },
            },
            MuiFormControlLabel: {
                styleOverrides: {
                    root: {
                        marginLeft: 0,
                    },
                    label: {
                        fontSize: "12px"
                    }
                }
            }
        },
    });

    const renderTitle = (text) => {
        return <span className={"dashboard-title"}>{text}</span>
    }

    const buildYearToDateTitle = () => {
        const map = getDateOfMonthMap();
        const month = new Date().getMonth() + 1;
        const year = new Date().getFullYear();

        if (currentYear !== year) {
            return "January - December (" + currentYear+")";
        }

        if (month === 1) {
            return "Year To Date";
        }

        return "Year To Date (January - " + map[month - 1].name + ")";
    }

    function handleMenu(obj) {
        setAnchorEl(obj.currentTarget);
    }

    function handleClose() {
        setAnchorEl(null);
    }

    function handleConfigure() {

        setExpenseModalOpen(true);
        handleClose();
    }

    function handleReconnect() {
        handleClose();
        window.location = "/api/v1/connectToQuickbooks";
    }

    function handleYearChange(obj) {
        setCurrentYear(obj.target.value);
        setFilter(defaultFilter);
        setPayload(defaultPayloadState);
    }

    function marshalMonthData(obj) {
        const ret = [];
        const mon = new Date().getMonth();
        let count = 0;

        for (let month of obj) {
            ret.push(month[filter]);
            count++;

            if (count === mon) {
                return ret;
            }
        }

        return ret;
    }

    function determineQuarter() {
        const month = new Date().getMonth();

        switch (month) {
            case 11:
            case 10:
            case 9:
                return 4;
            case 8:
            case 7:
            case 6:
                return 3;
            case 5:
            case 4:
            case 3:
                return 2;
            case 2:
            case 1:
            case 0:
            default:
                return 1;
        }
    }

    function marshallQuarterData(data) {

        let ret = [];
        const thisYear = new Date().getFullYear();

        if (thisYear !== currentYear) {
            return [
                data["q1"][filter],
                data["q2"][filter],
                data["q3"][filter],
                data["q4"][filter]
            ];
        }

        const currentQuarter = determineQuarter();

        for (let i = 1; i <= 4; i++) {

            if (currentQuarter > i) {
                ret.push(data["q" + i][filter]);
            } else if (currentQuarter === i) {
                ret.push(data["q" + i][filter]);
            }
        }

        return ret;
    }

    function calculateYears() {

        if (payload && payload.data) {
            let years = [];
            let thisYear = new Date().getFullYear();
            let startDate = payload.data.info.companyStartDate.split("T");
            let year = startDate[0].split("-")[0];

            for (let i = year; i <= thisYear; i++) {
                years.push(i);
            }

            return years;
        }

        return [new Date().getFullYear()];
    }

    function createFilterOptions() {

        if (payload && payload.data) {
            return Object.keys(payload.data.rolling12);
        }
    }

    function handleFilterChange(obj) {
        setFilter(obj.target.value);
    }

    function loadImageIfPossible() {

        if (payload.data.info.companyName.startsWith("Rancho")) {
            return <span style={{marginLeft: "40px"}}><img height={70} src={IMAGE_RANCHO}/></span>
        }
        else if (payload.data.info.companyName.startsWith("Tell Tail")) {
            return <span style={{marginLeft: "40px"}}>
                       <span><img height={70} src={IMAGE_TELLTAIL}/></span>
                    <span style={{marginLeft: "40px"}}><img height={70} src={IMAGE_MOONLIGHT}/></span>
            </span>

        }

        return "";
    }

    function renderDashboard() {
        return <React.Fragment>
            <div className={"dashboard-options"}>
                        <span>
                        <div style={{display: "grid", alignSelf: "end"}}>
                            <div style={{position: "relative", top: "5px", fontWeight: "bold"}}>Year</div>
                        </div>
                        <div>
                            <TextField size={"small"} select className={"dashboard-select"} value={currentYear}
                                       onChange={handleYearChange}>
                                {
                                    years.map((year) => {
                                        return <MenuItem key={"year_" + year} value={year}><span style={{
                                            width: "100%",
                                            textAlign: "right",
                                            fontWeight: "bold"
                                        }}>{year}</span></MenuItem>
                                    })
                                }

                            </TextField>
                        </div>
                        </span>

                <span style={{paddingLeft: "20px"}}>
                    <div style={{display: "grid", alignSelf: "end"}}>
                        <div style={{position: "relative", top: "5px", fontWeight: "bold"}}>Filter</div>
                    </div>
                    <div>
                        <TextField size={"small"} select className={"dashboard-select"} value={filter}
                                   onChange={handleFilterChange}>
                            {
                                filterOptions.map((option, idx) => {
                                    return <MenuItem key={"option_" + idx} value={option}>
                                    <span style={{
                                        width: "100%",
                                        textAlign: "right",
                                        fontWeight: "bold"
                                    }}>{option}</span>
                                    </MenuItem>
                                })
                            }

                        </TextField>
                    </div>
                </span>

                {loadImageIfPossible()}
            </div>

            {currentYear === new Date().getFullYear() ?
            <div className={"dashboard-container"}>
                <Paper elevation={defaultElevation}>
                    <div>
                        <MUIDataTable
                            title={renderTitle("Rolling 12 Months")}
                            data={[payload.data.rolling12[filter]]}
                            columns={DASHBOARD_COLUMNS}
                            options={options}
                        />
                    </div>
                </Paper>
            </div> : ""}
            <div className={"dashboard-container"}>
                <Paper elevation={defaultElevation}>
                    <div>
                        <MUIDataTable
                            title={renderTitle("Monthly Summary")}
                            data={marshalMonthData(payload.data.months)}
                            columns={DASHBOARD_COLUMNS}
                            options={options}
                        />
                    </div>
                </Paper>
            </div>
            <div className={"dashboard-container"}>
                <Paper elevation={defaultElevation}>
                    <div>
                        <MUIDataTable
                            title={renderTitle("Quarterly Summary")}
                            data={
                                marshallQuarterData(payload.data)
                            }
                            columns={DASHBOARD_COLUMNS}
                            options={options}
                        />
                    </div>
                </Paper>
            </div>
            <div className={"dashboard-container"}>
                <Paper elevation={defaultElevation}>
                    <div>
                        <MUIDataTable
                            title={renderTitle(buildYearToDateTitle())}
                            data={
                                [payload.data.ytd[filter]]
                            }
                            columns={DASHBOARD_COLUMNS}
                            options={options}
                        />
                    </div>
                </Paper>
            </div>
        </React.Fragment>
    }

    function doFirstTimeSetup() {
        setExpenseModalOpen(true);

        setPayload({
            ...payload,
            state: STATE_WAITING
        })
    }

    function loadManifest() {

        console.log("Loading manifest...");

        asyncFetchExpenseManifest((response) => {
            if (response.success) {
                setPayload({
                    manifest: response.manifest,
                    state: STATE_LOAD_PAYLOAD
                });
            }
            else {
                setPayload({
                    ...payload,
                    state: STATE_FIRST_TIME_SETUP
                })
            }
        }, (error) => {
            console.log(error);
        });
    }

    function loadPayload() {

        console.log("Loading payload...");
        asyncRequestEbidtaPayload(currentYear, (response) => {
            setPayload({
                ...payload,
                state: STATE_LOADED,
                data: response
            });
        }, (error) => {
            console.log(error);
        })
    }

    function handleDebugResponse(rsp) {
        if (rsp && rsp.success) {
            setPayload({
                state: 0
            });
        }
    }

    function injectProdSession() {

        console.log("Injecting prod session");

        const realmId = "9130356625221166";
        const accessToken = "eyJlbmMiOiJBMTI4Q0JDLUhTMjU2IiwiYWxnIjoiZGlyIn0..r-pdFfCD-CjI2arnZFqEtQ.5xQnEtj912jkOWetYeFYXTEtOtbB025r58cwVaen61kV_ES75vCyRCQjhFkjL0T1G5UwyVfFrjj2j4woElK2QKHPCFE_QpfjD6auFWeG7G-mzSXyya8-vRjSJx-zc5wxTfB27HhFZylomXa71I3T1jjhWboi7Dymmx_2haaDZvK1XbChkkRcXZT_nHff7aXOETR93gk-GY4J6MMSUI4CUnGlVdf1ePSDqY1ceBqYFZ-kkFXWZdZ4SU0NVXu7Jws5enYRaqeTGeUMGjf3KVzlaLKGuZ3MZprk5DcQ7a2UXmC_qQL_3vyjMAvBRgrfHC9HLBSHIKWJn5idI3n30shk6MU-EP70BnlevGKDPVETVrPGmlz1wvS4gwcF1nGyvqkuaUehPM6VQv6o_DjGdBg9gqp667sFUHj6VM64k63W3U2qfuZuAanLPIn1kblZ3FdzU0-Xv2xMRyJZS8p488ckIwWu81BPuDsRMd_IV_Rd9TZdP45NKthFCbAazsPB2vIzp-F9llSXaVxICNEEs-nLU89eS9a6jxZxlSbn59sTNOqcTuSP6wxbWbRfZmZ1-LKhLm5rJehR547063D80lyZs2NlX8F55NFfJgmuGoI4U4YUptEgxJIwTkvPabL92qcW62y5t1w2od3Q_HeQyo0s1nMHeZf4JPha8pidc3nlWqHHc4TMtmT-bA52amw3Us7WzXLuztG6H1OfpzZLK4fv5t_bT-zHi6PbiyxRyN7FGmo.6IbF381pSp7VldGcuhc8wQ";

        const uri = "/api/v1/injectsession?realmId=" + realmId +
            "&accessToken=" + accessToken;

        fetch(uri)
            .then(response => response.json())
            .then(response => handleDebugResponse(response))
            .catch(error => console.log(error));
    }

    function marshallExpenses(payload) {
        let ret = [];

        for (let idx in payload) {
            ret.push({ id: payload[idx].id, value: payload[idx].fullyQualifiedName });
        }

        return ret;
    }

    function loadExpenses() {
        console.log("Fetching expenses...");

        asyncFetchExpenseAccounts((response) => {

            if (response.success) {

                let expenses = marshallExpenses(response.payload);

                setPayload({
                    ...payload,
                    expenses: expenses,
                    state: STATE_LOAD_MANIFEST
                });
            } else {
                window.location = "/";
            }
        }, (error) => {
            window.location = "/";
        })
    }

    switch (payload.state) {
        case STATE_DEBUG: // DEBUG ONLY
            injectProdSession();
            break;
        case STATE_LOAD_MANIFEST:
            loadManifest();
            break;
        case STATE_LOAD_EXPENSES:
            loadExpenses();
            break;
        case STATE_LOAD_PAYLOAD:
            loadPayload();
            break;
        case STATE_FIRST_TIME_SETUP:
            doFirstTimeSetup();
            break;
        case STATE_LOADED:
            console.log("Fully loaded...");
            break;
        case STATE_WAITING:
            console.log("Doing nothing...");
            break;
        default:
            console.log("Hit unexpected state...");
            break;
    }

    function getStateText() {
            switch (payload.state) {
                case -1: // DEBUG ONLY
                    return "Injecting production credentials...";
                case 0:
                    return "Fetching manifest...";
                case 1:
                    return "Loading expenses...";
                case 2:
                    return "Fetching EBIDTA Payload...";
                    break;
                case 3:
                    return "Fully loaded...";
            }
        }

    return (
        <React.Fragment>
            <ThemeProvider theme={theme}>
                <AppBar position={"static"} color={"primary"}>
                    <Toolbar>
                        <div style={{flexGrow: "10.0", fontSize: "30px", fontWeight: "bold"}}>
                            EBITDA Dashboard
                        </div>
                        <div>
                            <IconButton
                                size="large"
                                onClick={handleMenu}
                                color="inherit"
                            >
                                <SettingsIcon/>
                            </IconButton>
                            <Menu
                                id="menu-appbar"
                                anchorEl={anchorEl}
                                anchorOrigin={{
                                    vertical: 'top',
                                    horizontal: 'right',
                                }}
                                keepMounted
                                transformOrigin={{
                                    vertical: 'top',
                                    horizontal: 'right',
                                }}
                                open={Boolean(anchorEl)}
                                onClose={handleClose}
                            >
                                <MenuItem onClick={handleConfigure}>Configure Account</MenuItem>
                                <Divider/>
                                <MenuItem onClick={handleReconnect}>Switch Accounts</MenuItem>
                            </Menu>
                        </div>
                    </Toolbar>
                </AppBar>

                {payload.data ? renderDashboard() : ""}

                {expenseModalOpen ? <ExpenseModal
                    manifest={payload.manifest}
                    callback={(val) => { setExpenseModalOpen(val); window.location="/load"; }}
                    expenses={payload.expenses}
                /> : ""}

                {payload.state !== 3 ? <ProgressModal text={getStateText()} open={true}/> : ""}


            </ThemeProvider>

        </React.Fragment>
    )
}